import React from 'react'
import { Form, Select } from 'antd'
import { getOptionsSelect } from '../util/FormHelper'

const FormIteamSpace = ({ spaces }) => {
    return (
        <Form.Item
            name="spaces"
            label="Espacios"
            rules={[{ required: true, message: 'Por favor ingresa los espacios' }]}
        >
            <Select
                showSearch
                filterOption={(input, option) =>
                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                mode="multiple"
                placeholder="Selecciona los espacios"
                style={{ width: '100%' }}
                options={getOptionsSelect(spaces)}
            />
        </Form.Item>
    )
}

export default FormIteamSpace